import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';

import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';

import { Observable, Subscription } from 'rxjs';

import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment-timezone';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, AbstractControl } from '@angular/forms';


import { ReservationFacility } from '../firestore-models/reservation-facility';
import { ReservationFacilityAttribute } from '../firestore-models/reservation-facility-attribute';
import { Reservation } from '../firestore-models/reservation';
import { ProjectLanguage } from '../firestore-models/project-language';
import { ApiReservation } from '../api-client-module';
import { ApiSetReservationsRequest } from '../api-client-module'

import { ApiClientService } from '../api-client.service';
import { ConfigurationService } from '../configuration.service';
import { SpinnerService } from '../services/spinner.service';
import { AppConst } from '../app-const';

import { ReservationDialogComponent } from './reservation-dialog/reservation-dialog.component';
import { MessageDialogComponent } from '../common/message-dialog/message-dialog.component';
import { SelectReservationDialogComponent } from './select-reservation-dialog/select-reservation-dialog.component';
import { ConfirmReservationDialogComponent } from './confirm-reservation-dialog/confirm-reservation-dialog.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-reservation',
  templateUrl: './reservation.component.html',
  styleUrls: ['./reservation.component.css'],
  standalone: false,
})
export class ReservationComponent implements OnInit, OnDestroy {

  // コレクション
  private reservationFacilitiesCollection!: AngularFirestoreCollection<ReservationFacility>;
  reservationFacilitiesObservable!: Observable<ReservationFacility[]>;
  reservationFacilitiesSubscribe!: Subscription;
  private reservationFacilityAttributesCollection!: AngularFirestoreCollection<ReservationFacilityAttribute>;
  reservationFacilityAttributesObservable!: Observable<ReservationFacilityAttribute[]>;
  reservationFacilityAttributesSubscribe!: Subscription;
  private reservationsCollection!: AngularFirestoreCollection<Reservation>;
  reservationsObservable!: Observable<Reservation[]>;
  reservationsSubscribe!: Subscription;
  //各予約設備情報に紐付くプロジェクトID
  projectId: string;
  //各予約設備情報に紐付くプロジェクトの言語情報
  projectLanguages!: Array<ProjectLanguage>;

  //予約設備情報テーブル
  displayedColumns: string[] = ['position', 'edit', 'select', 'attribute', 'reservation_facility_name', 'exhibit_id', 'reservation_no', 'company_name', 'name', 'email_address', 'use_start_date', 'use_end_date', 'use_times', 'reservation_status', 'mail_send_status', 'preview', 'created'];
  dataSource = new MatTableDataSource<Reservation>();
  selection = new SelectionModel<Reservation>(true, []);

  protected ATTR_SEARCH_WORD_PREFIX: string = 'reservationFacilityAttributes';

  attrCollectionName = AppConst.FIRESTORE_RESERVATION_FACILITY_ATTR;

  reservationFacilities!: Array<ReservationFacility>;
  reservationFacilityAttributes!: Array<ReservationFacilityAttribute>;

  searchFilter: any = {};

  uploadedFilesCollectionName = AppConst.FIRESTORE_UPLOADED_FILES;

  searchParameter = {
    facility_attribute_id: null,
    facility_id: null,
    start_date: null,
    end_date: null,
    status: 0,
    reservation_no: null,
    limit: 15,
    index: 0,
    doc: null,
    prev_doc: null,
    next_doc: null,
    next: true,
  } as any;
  isProcessing = false;

  editForm: UntypedFormGroup;
  get pagesize(): AbstractControl { return this.editForm.get('pagesize')!; }

  projectBaseLang: string = 'ja';

  //@ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;


  constructor(
    private router: Router,
    public dialog: MatDialog,
    private angularFirestore: AngularFirestore,
    private apiClientService: ApiClientService,
    private spinnerService: SpinnerService,
    private toastr: ToastrService,
    private configurationService: ConfigurationService,
    private formBuilder: UntypedFormBuilder,
    private translate: TranslateService
  ) {
    this.projectId = this.configurationService.getProjectId();
    moment.tz.setDefault('Asia/Tokyo');

    this.editForm = this.formBuilder.group({
      pagesize  : new UntypedFormControl({value: '15',  disabled: false}, []),
    });

  }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    //this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.setCustomFilter();
    this.projectBaseLang = this.configurationService.getProject().project_base_lang;
    // 予約設備取得
    this.reservationFacilitiesCollection = this.angularFirestore.collection<ReservationFacility>(
      AppConst.FIRESTORE_RESERVATION_FACILITIES, ref => ref.where('project_id', '==', this.projectId).orderBy('reservation_facility_id', 'asc'));
    this.reservationFacilitiesObservable = this.reservationFacilitiesCollection.valueChanges({ idField: 'id' });
    this.reservationFacilitiesSubscribe = this.reservationFacilitiesObservable.subscribe(reservationFacilities => {
      this.reservationFacilities = reservationFacilities;
    });

    // 予約設備属性取得
    this.reservationFacilityAttributesCollection = this.angularFirestore.collection<ReservationFacilityAttribute>(
      AppConst.FIRESTORE_RESERVATION_FACILITY_ATTR, ref => ref.where('project_id', '==', this.projectId).orderBy('attribute_id', 'asc'));
    this.reservationFacilityAttributesObservable = this.reservationFacilityAttributesCollection.valueChanges({ idField: 'id' });
    this.reservationFacilityAttributesSubscribe = this.reservationFacilityAttributesObservable.subscribe(reservationFacilityAttributes => {
      this.reservationFacilityAttributes = reservationFacilityAttributes;
    });

    // 予約取得
    this.getReservations();
  }

  ngOnDestroy(): void {
    this.reservationFacilitiesSubscribe.unsubscribe();
    this.reservationFacilityAttributesSubscribe.unsubscribe();
    this.reservationsSubscribe.unsubscribe();
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  checkboxLabel(row?: Reservation): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'}`;
  }

  // 編集ダイアログ
  openEditDialog(reservation: Reservation): void {
    const reservationStartDate: any = reservation!.reservation_start_date ? new Date(reservation!.reservation_start_date.seconds * 1000) : null;
    const reservationEndDate: any = reservation!.reservation_end_date ? new Date(reservation!.reservation_end_date.seconds * 1000) : null;
    const reservationCancelDate: any = reservation!.reservation_cancel_date ? new Date(reservation!.reservation_cancel_date.seconds * 1000) : null;
    const birthday: any = reservation!.birthday ? new Date(reservation!.birthday.seconds * 1000) : null;
    const created: any = reservation!.created ? new Date(reservation!.created.seconds * 1000) : null;
    const updated: any = reservation!.updated ? new Date(reservation!.updated.seconds * 1000) : null;
    let apiReservation: ApiReservation = {
      id: reservation.id,
      project_id: reservation.project_id,
      facility_id: reservation.facility_id,
      exhibit_id: reservation.exhibit_id,
      reservation_facility_id: reservation.reservation_facility_id,
      reservation_facility_attribute_id: reservation.reservation_facility_attribute_id,
      reservation_no: reservation.reservation_no,
      reservation_status: reservation.reservation_status,
      reservation_start_date: reservationStartDate,
      reservation_end_date: reservationEndDate,
      reservation_times: reservation.reservation_times ? reservation.reservation_times : [],
      reservation_cancel_date: reservationCancelDate,
      reservation_cancel_user: reservation.reservation_cancel_user,
      email_address: reservation.email_address,
      company_name: reservation.company_name,
      department: reservation.department,
      job_title: reservation.job_title,
      surname_chinese: reservation.surname_chinese,
      name_chinese: reservation.name_chinese,
      family_name: reservation.family_name,
      first_name: reservation.first_name,
      birthday: birthday,
      gender: reservation.gender,
      postal_code: reservation.postal_code,
      prefecture: reservation.prefecture,
      municipalities: reservation.municipalities,
      street_address: reservation.street_address,
      name_and_number_building: reservation.name_and_number_building,
      mobile_phone_number: reservation.mobile_phone_number,
      user_request: reservation.user_request,
      memo: reservation.memo,
      mail_send_status: reservation.mail_send_status,
      notification_mode: reservation.notification_mode,
      answer: reservation.answer,
      preview: reservation.preview,
      user_site_url: reservation.user_site_url,
      splats_qr_code: reservation.splats_qr_code,
      splats_guest_id: reservation.splats_guest_id,
      enabled: reservation.enabled,
      created: created,
      updated: updated,
    };
    let curReservationFacility = null;
    for (const reservationFacility of this.reservationFacilities) {
      if (reservationFacility.reservation_facility_id === reservation.reservation_facility_id) {
        curReservationFacility = reservationFacility;
      }
    }
    const dialogRef = this.dialog.open(ReservationDialogComponent, {
      width: '85%',
      disableClose: true,
      data: { change_type: AppConst.DATA_CHANGE_TYPE_UPDATE, reservation: apiReservation, reservationFacility: curReservationFacility }
    });
  }

  //削除
  deleteData(): void {
    const dialogRef = this.dialog.open(MessageDialogComponent, {
      width: '420px',
      height: '180px',
      disableClose: true,
      data: { message: this.translate.instant('選択されたデータを削除します。よろしいですか？') }
    });

    dialogRef.afterClosed().subscribe(result => {
      let selectedReservations: Array<ApiReservation> = new Array<ApiReservation>();
      for (const row of this.dataSource.data) {
        const reservationStartDate: any = row.reservation_start_date ? new Date(row.reservation_start_date.seconds * 1000) : null;
        const reservationEndDate: any = row.reservation_end_date ? new Date(row.reservation_end_date.seconds * 1000) : null;
        const reservationCancelDate: any = row!.reservation_cancel_date ? new Date(row!.reservation_cancel_date.seconds * 1000) : null;
        const birthday: any = row.birthday ? new Date(row.birthday.seconds * 1000) : null;
        const created: any = row!.created ? new Date(row!.created.seconds * 1000) : null;
        const updated: any = row!.updated ? new Date(row!.updated.seconds * 1000) : null;
        if (this.selection.isSelected(row)) {
          const selectedReservation: ApiReservation = {
            id: row.id,
            project_id: row.project_id,
            facility_id: row.facility_id,
            exhibit_id: row.exhibit_id,
            reservation_facility_id: row.reservation_facility_id,
            reservation_facility_attribute_id: row.reservation_facility_attribute_id,
            reservation_no: row.reservation_no,
            reservation_status: row.reservation_status,
            reservation_start_date: reservationStartDate,
            reservation_end_date: reservationEndDate,
            reservation_times: row.reservation_times,
            reservation_cancel_date: reservationCancelDate,
            reservation_cancel_user: row.reservation_cancel_user,
            email_address: row.email_address,
            company_name: row.company_name,
            department: row.department,
            job_title: row.job_title,
            surname_chinese: row.surname_chinese,
            name_chinese: row.name_chinese,
            family_name: row.family_name,
            first_name: row.first_name,
            birthday: birthday,
            gender: row.gender,
            postal_code: row.postal_code,
            prefecture: row.prefecture,
            municipalities: row.municipalities,
            street_address: row.street_address,
            name_and_number_building: row.name_and_number_building,
            mobile_phone_number: row.mobile_phone_number,
            user_request: row.user_request,
            memo: row.memo,
            mail_send_status: row.mail_send_status,
            notification_mode: row.notification_mode,
            answer: row.answer,
            preview: row.preview,
            user_site_url: row.user_site_url,
            splats_qr_code: row.splats_qr_code,
            splats_guest_id: row.splats_guest_id,
            enabled: row.enabled,
            created: created,
            updated: updated
          };
          selectedReservations.push(selectedReservation);
        }
      }
      if (!!result) {
        let request: ApiSetReservationsRequest = {
          access_token: '',
          change_type: AppConst.DATA_CHANGE_TYPE_DELETE,
          reservations: selectedReservations
        }
        this.spinnerService.openSpinner();
        this.apiClientService.setReservations(request).then(
          response => {
            if (response!.ret === AppConst.API_RET_SUCCESS) {
              this.toastr.success(this.translate.instant('削除しました。'));
            } else {
              if (response!.ret === AppConst.API_RET_IN_USE_DATA) {
                this.toastr.error(this.translate.instant('削除できませんでした。フロア・表示グループ情報で利用中のデータが含まれている可能性があります。'));
              } else {
                this.toastr.error(this.translate.instant('削除できませんでした。'));
              }
            }
          }
        ).catch(
          error => {
            console.log(error);
            this.toastr.error(this.translate.instant('削除できませんでした。'));
          }
        ).finally(
          () => {
            this.spinnerService.closeSpinner();
            this.selection.clear();
          }
        );
      }
    });
  }

  sortData(sort: Sort) {
    const data = this.dataSource.data.slice();
    if (!sort.active || sort.direction === '') {
      this.dataSource.data = data;
      return;
    }
    const compare = (a: number | string | boolean, b: number | string | boolean, isAsc: boolean) => {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }

    this.dataSource.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'reservation_facility_id':
          return compare(a.reservation_facility_id, b.reservation_facility_id, isAsc);
        case 'attribute':
          const aAttr = a.reservation_facility_attribute_id ? a.reservation_facility_attribute_id : '';
          const bAttr = b.reservation_facility_attribute_id ? b.reservation_facility_attribute_id : '';
          return compare(aAttr, bAttr, isAsc);
        case 'reservation_facility_name':
          return compare(a.reservation_facility_id, b.reservation_facility_id, isAsc);
        case 'reservation_no':
          return compare(a.reservation_no, b.reservation_no, isAsc);
        case 'company_name':
          return compare(a.company_name, b.company_name, isAsc);
        case 'department':
          return compare(a.department, b.department, isAsc);
        case 'name':
          return compare(a.family_name, b.family_name, isAsc);
        case 'email_address':
          return compare(a.email_address, b.email_address, isAsc);
        case 'use_start_date':
          return compare(a.reservation_start_date.toMillis(), b.reservation_start_date.toMillis(), isAsc);
        case 'reservation_status':
          return compare(a.reservation_status, b.reservation_status, isAsc);
        case 'mail_status':
          return compare(a.mail_send_status, b.mail_send_status, isAsc);
        case 'preview':
          return compare(a.preview, b.preview, isAsc);
        case 'created':
          return compare(a.created.toMillis(), b.created.toMillis(), isAsc);
        case 'updated':
          return compare(a.updated.toMillis(), b.updated.toMillis(), isAsc);
        default:
          return 0;
      }
    });
  }

  setCustomFilter() {
    // NOTE: AND検索
    this.dataSource.filterPredicate = (data: any, filter: any) => {
      let matchCount = 0;
      let keys = Object.keys(filter);
      for (const key of keys) {
        if (!filter[key]) {
          // フィルタに値がない場合は全抽出
          matchCount++;
        } else {
          if (data[key].trim().toLowerCase().indexOf(filter[key]) !== -1) {
            matchCount++;
          }
        }
      }
      return (keys.length === matchCount);
    };
  }

  addFilterValue(docs: Array<any>): Array<any> {
    for (const doc of docs) {
      let filterValue = '';
      let reservationFacilityName = '';
      let preview = '';
      for (let reservationFacility of this.reservationFacilities) {
        if (doc.reservation_facility_id === reservationFacility.reservation_facility_id) {
          reservationFacilityName = reservationFacility.reservation_facility_names[0].name;
        }
        if (doc.preview === false) {
          preview = this.translate.instant('本番');
        } else if (doc.preview === true) {
          preview = this.translate.instant('プレ');
        }
      }
      filterValue += reservationFacilityName + ' ' + doc.email_address + ' ' + doc.family_name + ' ' + doc.first_name + ' ' + doc.exhibit_id + ' ' + preview;
      doc['filterValue'] = filterValue;
      doc['filterValueAttr'] = this.ATTR_SEARCH_WORD_PREFIX + doc.reservation_facility_attribute_id;
    }
    return docs;
  }

  applyFilter(event: Event) {
    this.selection.clear();
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchFilter['filterValue'] = filterValue.trim().toLowerCase();
    this.dataSource.filter = this.searchFilter;
  }

  applyFilterAttr(event: any) {
    this.selection.clear();
    let filterValue = '';
    if (event.value) {
      filterValue = this.ATTR_SEARCH_WORD_PREFIX + event.value;
    }
    this.searchFilter['filterValueAttr'] = filterValue.trim().toLowerCase();
    this.dataSource.filter = this.searchFilter;
  }

  openSearch(): void {
    const dialogRef = this.dialog.open(SelectReservationDialogComponent, {
      width: '640px',
      disableClose: true,
      data: this.searchParameter
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        console.log(result);
        this.searchParameter.facility_attribute_id = result.facility_attribute_id;
        this.searchParameter.facility_id = result.facility_id;
        this.searchParameter.start_date = result.start_date;
        this.searchParameter.end_date = result.end_date;
        this.searchParameter.status = result.status;
        this.searchParameter.reservation_no = result.reservation_no;
        this.searchParameter.index = 0;
        this.searchParameter.doc = null;
        this.searchParameter.next = true;
        this.getReservations();
      }
    });
  }

  async getReservations(): Promise<void> {
    if (this.isProcessing) {
      return;
    }

    this.isProcessing = true;    

    if (!!this.reservationsSubscribe) {
      this.reservationsSubscribe.unsubscribe();
    }
    this.reservationsCollection = this.angularFirestore.collection<Reservation>(AppConst.FIRESTORE_RESERVATIONS, ref => 
    {
      let query: any = ref;
      query = query.where('project_id', '==', this.projectId);
      if (!!this.searchParameter.facility_attribute_id) { 
        query = query.where('reservation_facility_attribute_id', '==', this.searchParameter.facility_attribute_id);
      };
      if (!!this.searchParameter.facility_id) { 
        query = query.where('reservation_facility_id', '==', this.searchParameter.facility_id);
      };
      if (!!this.searchParameter.start_date && !!this.searchParameter.end_date) { 
        const startDate = moment(this.searchParameter.start_date, 'YYYYMMDD').toDate();
        const endDate = moment(this.searchParameter.end_date, 'YYYYMMDD').toDate();
        query = query.where('reservation_start_date', '>=', startDate);
        query = query.where('reservation_start_date', '<=', endDate);
      };
      if (!!this.searchParameter.status) { 
        query = query.where('reservation_status', '==', this.searchParameter.status);
      };
      if (!!this.searchParameter.reservation_no) {
        query = query.where('reservation_no', '==', this.searchParameter.reservation_no);
      } else {
        if (!!this.searchParameter.facility_id) { 
          query = query.orderBy('reservation_start_date', 'desc');
        } else {
          if (!!this.searchParameter.start_date && !!this.searchParameter.end_date) { 
            query = query.orderBy('reservation_start_date', 'desc');
            query = query.orderBy('reservation_facility_id', 'asc');
          } else {
            query = query.orderBy('reservation_facility_id', 'asc');
            query = query.orderBy('reservation_start_date', 'desc');
          }
        }
      }
      if (!!this.searchParameter.doc) {
        if (this.searchParameter.next) {
          query = query.startAfter(this.searchParameter.doc);
        } else {
          query = query.endBefore(this.searchParameter.doc);
        }
      }
      if (this.searchParameter.next) {
        query = query.limit(this.searchParameter.limit + 1);
      } else {
        query = query.limitToLast(this.searchParameter.limit + 1);
      }
      return query;
    });


    this.reservationsObservable = this.reservationsCollection.valueChanges({ idField: 'id' });
    this.reservationsSubscribe = this.reservationsObservable.subscribe(async reservations => {

      // 次回検索開始位置を保持
      this.searchParameter.next_doc = null;
      if (reservations.length > 0) {
        if (this.searchParameter.next) {
          const subPrev = this.angularFirestore.collection(AppConst.FIRESTORE_RESERVATIONS).doc(reservations[0].id).get().subscribe(doc => {
            subPrev.unsubscribe();
            this.searchParameter.prev_doc = doc;
          });
          if (reservations.length > this.searchParameter.limit) {
            const subNext = this.angularFirestore.collection(AppConst.FIRESTORE_RESERVATIONS).doc(reservations[this.searchParameter.limit - 1].id).get().subscribe(doc => {
              subNext.unsubscribe();
              this.searchParameter.next_doc = doc;
            });
          }
        } else {
          if (reservations.length > this.searchParameter.limit) {
            const subPrev = this.angularFirestore.collection(AppConst.FIRESTORE_RESERVATIONS).doc(reservations[1].id).get().subscribe(doc => {
              subPrev.unsubscribe();
              this.searchParameter.prev_doc = doc;
            });
          } else {
            this.searchParameter.prev_doc = null;
          }
          const subNext = this.angularFirestore.collection(AppConst.FIRESTORE_RESERVATIONS).doc(reservations[reservations.length - 1].id).get().subscribe(doc => {
            subNext.unsubscribe();
            this.searchParameter.next_doc = doc;
          });
        }
        reservations = reservations.slice(0, this.searchParameter.limit); 
      } else {
        this.searchParameter.index = 0;
        this.searchParameter.doc = null;
        this.searchParameter.prev_doc = null;
      }
      this.dataSource.data = this.addFilterValue(reservations);



      this.isProcessing = false;    
    });
  
  }

  openConfirmDialog(reservation : Reservation) {
    for (const facility of this.reservationFacilities) {
      if (facility.reservation_facility_id === reservation.reservation_facility_id) {
        const param = {
          reservation: reservation,
          facility: facility
        };
        const dialogRef = this.dialog.open(ConfirmReservationDialogComponent, {
          width: '80%',
          height: '90%',
          disableClose: true,
          data: param
        });
        dialogRef.afterClosed().subscribe(result => {
        });
    
        break;
      }
    }
  }

  // ページサイズ変更
  onPageSizeChange(event: any) {
    this.searchParameter.limit = Number(this.pagesize.value)
    this.searchParameter.index = 0;
    this.searchParameter.doc = null;
    this.searchParameter.next = true;
    this.getReservations();
  }

  // 前へ
  onPrevClick() {
    this.searchParameter.index--;
    this.searchParameter.doc = this.searchParameter.prev_doc;
    this.searchParameter.next = false;
    this.getReservations();
  }

  // 次へ
  onNextClick() {
    this.searchParameter.index++;
    this.searchParameter.doc = this.searchParameter.next_doc;
    this.searchParameter.next = true;
    this.getReservations();
  }}
